export const navigation = [
  {title: true, name: 'Meets'},
  {divider: true},
  {name: 'Dashboard',  url: '/dashboard',  icon: 'icon-chart',  badge: { variant: 'info',   text: 'NEW' }},
  {name: 'Tabelas',  url: '/base',  icon: ' icon-control-play',  children: [
    {name: 'Setor',  url: '/setor',  icon: 'fa fa-user-circle-o'},
    {name: 'Atendente',  url: '/atendente',  icon: 'fa fa-user-circle-o'},
    {name: 'Intervalos',  url: '/intervalos',  icon: 'fa fa-list-ol'},
    {name: 'Dicas',  url: '/dicas',  icon: 'fa fa-clock-o'},
    {name: 'Departamento',  url: '/departamento',  icon: 'fa fa-address-book-o' , badge: { variant: 'success',   text: '' }},
    {name: 'Natureza',  url: '/natureza',  icon: 'fa fa-address-book-o'},
    {name: 'Status da Denúncia',  url: '/status',  icon: 'fa fa-user-circle-o'},
    {name: 'Clientes',  url: '/cliente',  icon: 'fa fa-users'},
    {name: 'Usuários (Leads)',  url: '/contato',  icon: 'fa fa-phone-square'},
    {name: 'Listas',  url: '/lista',  icon: 'fa fa-list-alt',  badge: { variant: 'info',   text: '' }},
    {name: 'Agenda de Contatos',  url: '/agenda',  icon: 'fa fa-phone-square'},
  ]},
  {title: true,  name: 'Atendimento'},
  {name: 'Denúncias',  url: '/denuncia',  icon: 'fa fa-wechat'},
  {name: 'Mensagens',  url: '/mensagem',  icon: 'fa fa-list-ol'},
  {name: 'Atendente',  url: '/atendimento',  icon: 'fa fa-wechat'},
  {name: 'Ouvidoria',  url: '/ouvidoria',  icon: 'fa fa-list-ol'},
  {name: 'Chat',  url: '/chatSetor',  icon: 'fa fa-wechat'},
  {name: 'Enviar Msg',  url: '/whatscall',  icon: 'fa fa-whatsapp'},
  {title: true,  name: 'Processos'},
  {name: 'Bots',  url: '/pergunta',  icon: 'fa fa-whatsapp'},
  {name: 'Template do Bot',  url: '/template',  icon: 'fa fa-whatsapp'},
  {name: 'Intensão do Bot',  url: '/chatbot',  icon: 'icon-user'},
  {name: 'Notícias',  url: '/noticia',  icon: 'icon-feed'},
  {name: 'Publicidade',  url: '/publicidade',  icon: 'icon-feed'},
  {name: 'Classificados',  url: '/classificado',  icon: 'icon-puzzle'},
  {name: 'Promoções',  url: '/promocao',  icon: 'icon-settings'},
  {name: 'Enquete',  url: '/enquete',  icon: 'icon-pencil'},
  {name: 'Pesquisa',  url: '/pesquisa',  icon: 'icon-pencil'},
  {name: 'Galeria',  url: '/galeria',  icon: 'icon-social-youtube'},
  {name: 'Empregos',  url: '/emprego',  icon: 'icon-calendar'},
  {name: 'Disparo de Msg',  url: '/campanha',  icon: 'fa fa-feed' , badge: { variant: 'success',   text: '' }},
  {name: 'Relatórios',  url: '/base',  icon: ' icon-control-play',  children: [
      {name: 'Relatórios de Atendimentos',  url: '/home',  icon: 'icon-feed', badge: { variant: 'warning',   text: '' }},
      {name: 'Relatórios de Atendentes',  url: '/home',  icon: 'icon-calendar', badge: { variant: 'info',   text: '' }},
      {name: 'Relatórios de Telefones',  url: '/home',  icon: 'icon-social-youtube', badge: { variant: 'info',   text: 'EM BREVE' }}
  ]},
  {name: 'Tools',  url: '/base2',  icon: 'icon-support',  children: [
    {name: 'Parametros',  url: '/parametros',  icon: 'icon-settings'},
    {name: 'Resposta Rápida',  url: '/whatsresposta',  icon: 'icon-settings'},
    {name: 'Log',  url: '/log',  icon: 'icon-user'},
    {name: 'Intensão',  url: '/intensao',  icon: 'icon-user'},
    {name: 'Grupos',  url: '/grupo',  icon: 'fa fa-users',  badge: { variant: 'info',   text: '' }},
    {name: 'Usuários',  url: '/usuario',  icon: 'icon-user',  badge: { variant: 'info',   text: '' }}
  ]},
/*
  {name: 'Icons',  url: '/icons',  icon: 'icon-star',  children: [
    {name: 'Flags',  url: '/icons/flags',  icon: 'icon-star',  badge: {variant: 'success',  text: 'NEW'}},
    {name: 'Font Awesome',  url: '/icons/font-awesome', icon: 'icon-star', badge: {variant: 'secondary', text: '4.7'}},
    {name: 'Simple Line Icons', url: '/icons/simple-line-icons', icon: 'icon-star'}
  ]
},
  {name: 'Colors',  url: '/theme/colors',  icon: 'icon-drop'},
  {name: 'Typography',  url: '/theme/typography',  icon: 'icon-pencil'},
  {title: true,  name: 'Components'},
  {name: 'Base',  url: '/base',  icon: 'icon-puzzle',  children: [
      {name: 'Cards',  url: '/base/cards',  icon: 'icon-puzzle'},
      {name: 'Carousels',  url: '/base/carousels',  icon: 'icon-puzzle'},
      {name: 'Collapses',  url: '/base/collapses',  icon: 'icon-puzzle'},
      {name: 'Forms',  url: '/base/forms',  icon: 'icon-puzzle'},
      {name: 'Pagination',  url: '/base/paginations',  icon: 'icon-puzzle'},
      {name: 'Popovers',  url: '/base/popovers',  icon: 'icon-puzzle'},
      {name: 'Progress',  url: '/base/progress',  icon: 'icon-puzzle'},
      {name: 'Switches',  url: '/base/switches',  icon: 'icon-puzzle'},
      {name: 'Tables',  url: '/base/tables',  icon: 'icon-puzzle'},
      {name: 'Tabs',  url: '/base/tabs',  icon: 'icon-puzzle'},
      {name: 'Tooltips',  url: '/base/tooltips',  icon: 'icon-puzzle'}
    ]
  },
  {name: 'Buttons',  url: '/buttons',  icon: 'icon-cursor', children: [
      {name: 'Buttons',  url: '/buttons/buttons',  icon: 'icon-cursor'},
      {name: 'Dropdowns',  url: '/buttons/dropdowns',  icon: 'icon-cursor'},
      {name: 'Social Buttons',  url: '/buttons/social-buttons',  icon: 'icon-cursor'}
    ]
  },
  {name: 'Charts', url: '/charts', icon: 'icon-pie-chart'},
  {name: 'Icons',  url: '/icons',  icon: 'icon-star',  children: [
      {name: 'Flags',  url: '/icons/flags',  icon: 'icon-star',  badge: {variant: 'success',  text: 'NEW'}},
      {name: 'Font Awesome',  url: '/icons/font-awesome', icon: 'icon-star', badge: {variant: 'secondary', text: '4.7'}},
      {name: 'Simple Line Icons', url: '/icons/simple-line-icons', icon: 'icon-star'}
    ]
  },
  {name: 'Notifications', url: '/notifications', icon: 'icon-bell', children: [
      {name: 'Alerts', url: '/notifications/alerts', icon: 'icon-bell'},
      {name: 'Modals', url: '/notifications/modals', icon: 'icon-bell'}
    ]
  },

{name: 'Projeto', url: 'http://icstech.com.br', icon: 'icon-cloud-download', class: 'mt-auto', variant: 'success'},
{name: 'ICS Tech', url: 'http://icstech.com.br', icon: 'icon-layers', variant: 'danger'}
*/
];



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/app/_nav.ts